
import axios from 'axios';

/*
 Developer Guide: axios client uses '/api' base and attaches JWT from localStorage.
 Vite dev proxy rewrites /api to backend, so frontend code doesn't need backend host.
*/ 
const api = axios.create({
  baseURL: '/api' // proxied to backend in dev by vite.config.js
});

api.interceptors.request.use(config => {
  const auth = JSON.parse(
        localStorage.getItem("auth") || "{}"
    );
    const token = auth.accessToken;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// ✅ AUTO LOGOUT ON 401
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            const auth = JSON.parse(
                localStorage.getItem("auth") || "{}"
            );
            if (auth.accessToken) {
                localStorage.removeItem("auth");
                window.location.href = "/authlogin";
            }
        }
        return Promise.reject(error);
    }
);

export default api;
